// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__s7wWu","row":"Node_row__iONDM","label":"Node_label__zJvSf","footer":"Node_footer__23zJN"};